import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse } from "axios";
import Vue from "vue";

export const EventBus = new Vue();

const DEFAULT_TIME = 1500;

export const apiClient: AxiosInstance = axios.create({
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
});

let startTime: number;
let timeouts: NodeJS.Timeout[] = [];
let waitingApiCalls: number = 0;

function startLoaderTimeout(): void {
    const timeout = setTimeout(() => {
        EventBus.$emit('startLoading');
    }, 500);

    timeouts.push(timeout);
}

function clearAllTimeouts(): void {
    if (timeouts.length > 0) {
        for (const id in timeouts) {
            clearTimeout(timeouts[id]);
        }

        timeouts = [];
    }
}

apiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    if (waitingApiCalls <= 1) {
        startTime = Date.now();
        startLoaderTimeout();
    }

    waitingApiCalls++;

    return config;
});

apiClient.interceptors.response.use((response: AxiosResponse) => {
    waitingApiCalls--;

    if (waitingApiCalls >= 1) {
        return response;
    }

    const elapsedTime = Date.now() - startTime;

    if (elapsedTime < 480) {
        clearAllTimeouts();
    } else {
        if (elapsedTime <= DEFAULT_TIME) {
            setTimeout(() => {
                EventBus.$emit('doneLoading');
            }, (DEFAULT_TIME - elapsedTime));
        } else {
            EventBus.$emit('doneLoading');
        }
    }

    EventBus.$emit('doneLoading');

    return response;
}, (error) => {
    waitingApiCalls--;

    if (waitingApiCalls === 0) {
        clearAllTimeouts();
        EventBus.$emit('doneLoading');
    }

    return Promise.reject(error);
});
